import isNil from 'lodash.isnil';
// Checks if value is null or undefined.
export var customIsNil = function (value) { return isNil(value); };
//# sourceMappingURL=functions.js.map